var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._ssrNode("<p class=\"title\" data-v-89d0db98>"+_vm._ssrEscape(_vm._s(_vm.title))+"</p> <div class=\"line\" data-v-89d0db98></div> <div class=\"item\" data-v-89d0db98>"+(_vm._s(_vm.text))+"</div>")])
}
var staticRenderFns = []

export { render, staticRenderFns }